import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "status", "preview", "submit"]
  static values = {
    url: { type: String, default: "/welcome/check_username" },
    available: String,
    taken: String,
    reserved: String,
    current: String
  }

  connect() {
    this.timeout = null
    this.updateSubmitState(false)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  check() {
    const username = this.inputTarget.value.trim().toLowerCase()

    // Update preview
    if (this.hasPreviewTarget) {
      this.previewTarget.textContent = username || "yourname"
    }

    if (this.timeout) clearTimeout(this.timeout)

    // Same as current username — no action needed
    if (this.hasCurrentValue && username === this.currentValue) {
      this.statusTarget.textContent = ""
      this.statusTarget.className = "username-check-status"
      this.updateSubmitState(false)
      return
    }

    if (username.length < 3) {
      this.statusTarget.textContent = ""
      this.statusTarget.className = "username-check-status"
      this.updateSubmitState(false)
      return
    }

    this.updateSubmitState(false)
    this.timeout = setTimeout(() => this.lookup(username), 300)
  }

  async lookup(username) {
    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("username", username)

      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      })

      if (!response.ok) return

      const data = await response.json()
      // Only update if input hasn't changed
      if (this.inputTarget.value.trim().toLowerCase() !== username) return

      if (data.available) {
        this.statusTarget.textContent = this.availableValue || "✓ Available"
        this.statusTarget.className = "username-check-status username-check-available"
        this.updateSubmitState(true)
      } else if (data.reason === "reserved") {
        this.statusTarget.textContent = this.reservedValue || "✗ Reserved"
        this.statusTarget.className = "username-check-status username-check-unavailable"
        this.updateSubmitState(false)
      } else {
        this.statusTarget.textContent = this.takenValue || "✗ Taken"
        this.statusTarget.className = "username-check-status username-check-unavailable"
        this.updateSubmitState(false)
      }
    } catch {
      // Silently fail
    }
  }

  updateSubmitState(enabled) {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = !enabled
  }
}
